<template>
	<MainPageLayout>
		<v-container class="px-2 py-1">
			<ProductionTerms />
		</v-container>
	</MainPageLayout>
</template>

<script>
	import MainPageLayout from "../layouts/MainPageLayout";
	import ProductionTerms from "../components/Others/ProductionTerms/ProductionTerms";

	export default {
		data: () => ({
			show: false
		}),
		components: {
			MainPageLayout,
			ProductionTerms
		}
	};
</script>
